import { TextButton as Button } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { COLORS } from '../../../styles/variables';
import { device } from '../../../styles/devices';

export const TileWrapper = styled.div`
  width: 356px;
  background-color: ${COLORS.white};
  padding: 24px 24px 20px 24px;
  height: 856px;
  /* min-height: 255px; */
  display: flex;
  flex-direction: column;
`;

export const BuildCta = styled(Button)`
  color: ${COLORS.grey60} !important;
  div:nth-child(2) {
    flex-direction: row-reverse;
    gap: 4px;
  }
`;

export const TagAndBuildWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
`;

export const NameAndTrimWrapper = styled.div`
  display: flex;
  height: 104px;
  gap: 8px;
  flex-direction: column;
  text-align: center;
`;

export const ImageWrapper = styled.div`
  margin: 24px 0;
  display: flex;
  justify-content: center;
  /* position: relative; */
  /* height: 246px; */
`;

export const VehicleImage = styled.img<{ isImageExist?: boolean }>`
  width: 260px;
  height: 132px;
  object-fit: cover;
  /* position: absolute;
  top: -8px;
  left: 26px; */
  scale: ${({ isImageExist }) => (isImageExist ? 1.4 : 1.2)};
  @media ${device.mobileL} {
    width: 296px;
  }
`;

export const MSRPWrapper = styled.div`
  gap: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
  margin-bottom: 16px;
`;

export const OfferAndCtaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const CreditContainer = styled.div`
  height: 65px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const CreditCTA = styled.button`
  border: none;
  background: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding-top: 16px;
  padding-bottom: 24px;
  /* border-top: 1px solid ${COLORS.grey15}; */
`;

export const CTAsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const MainCta = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: none;
  box-shadow: inset 0 0 0 1px ${COLORS.black};
  width: 100%;
  padding: 16px 32px;
  font-family: 'Audi Type';
  color: ${COLORS.black};
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.002px;
`;

export const InventoryCTA = styled(Button)`
  div:nth-child(2) {
    flex-direction: row-reverse;
    gap: 4px;
  }
`;

export const PriceCopy = styled.h4<{ isBold?: boolean }>`
  margin: 0;
  font-family: 'Audi Type';
  letter-spacing: 0.001px;
  font-size: 18px;
  line-height: 28px;
  font-weight: ${(props) => (props.isBold ? '700' : '400')};
  color: ${COLORS.grey80};
`;

export const BonusOfferTitle = styled.h4`
  /* padding-top: 24px; */
  padding-bottom: 12px;
  font-family: 'Audi Type Extended';
  letter-spacing: 0.002px;
  font-size: 18px;
  line-height: 28px;
`;
